<section class="dashboard-main container-fluid">
    <div class="contents-main">
        <div class="card table-card">
            <!-- Title, filters and the page actions share one row at the top
                 of the card rather than stacking above it. -->
            <div class="table-toolbar">
                <h1 class="table-toolbar__title">Audit Trail</h1>
                <div class="sb-filter-holder sb-filter-holder--inline">
                    <!-- Date Range Filter -->
                    <!-- <div class="filter-item filter-date"> -->
                    <div class="input-wrapper daterange-wrapper">
                        <!-- <input type="text" class="sb-filter-field sb-filter-field--md" bsDatepicker
                            [(ngModel)]="selectedDate" [bsConfig]="datePickerConfig" #dp="bsDatepicker"
                            (ngModelChange)="onRangeChange($event)" placeholder="Month" /> -->
                        <input type="text" class="form-control" bsDaterangepicker [(ngModel)]="selectedRange"
                            [bsConfig]="datePickerConfig" #dp="bsDaterangepicker" (ngModelChange)="onRangeChange($event)"
                            placeholder="Date" />

                        <span class="sb-filter-date-icon" (click)="dp.toggle()">
                            <span><svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16"
                                    fill="none">
                                    <path
                                        d="M12.8046 1.60066H12.0042V0H10.4036V1.60066H4.00087V0H2.40021V1.60066H1.59987C1.39011 1.60066 1.18241 1.64213 0.988734 1.72268C0.795054 1.80324 0.619218 1.9213 0.471327 2.07006C0.323435 2.21882 0.206406 2.39535 0.126986 2.5895C0.0475649 2.78365 0.00731745 2.99157 0.00854826 3.20133L0.000549316 14.3993C0.000549316 14.8239 0.169189 15.231 0.469373 15.5312C0.769556 15.8314 1.17669 16 1.60121 16H12.7992C13.2237 16 13.6309 15.8314 13.9311 15.5312C14.2312 15.231 14.3999 14.8239 14.3999 14.3993V3.20133C14.3999 2.77773 14.232 2.37141 13.933 2.07138C13.6339 1.77135 13.2282 1.60208 12.8046 1.60066ZM12.8046 14.398H1.60655V5.59433H12.8046V14.398Z"
                                        fill="currentColor" />
                                </svg></span>
                        </span>
                    </div>
                    <!-- </div> -->
                    <!-- Change By Filter -->
                    <div class="input-wrapper">
                        <ng-select [items]="usersList" bindLabel="username" bindValue="user_id" placeholder="Change By"
                            class="sb-filter-field sb-filter-field--md" (change)="selectedChangeBy($event)">
                        </ng-select>
                    </div>

                    <!-- Event Type Filter -->
                    <div class="input-wrapper">
                        <ng-select [items]="eventTypeList" bindLabel="name" bindValue="id" placeholder="Event Type"
                            class="sb-filter-field sb-filter-field--md" (change)="selectedEventType($event)">
                        </ng-select>
                    </div>

                    <!-- Action Type Filter -->
                    <div class="input-wrapper">
                        <ng-select [items]="actionTypeList" bindLabel="name" bindValue="id" placeholder="Action Type"
                            class="sb-filter-field sb-filter-field--md" (change)="selectedActionType($event)">
                        </ng-select>
                    </div>
                    <!-- Search -->
                    <div class="btn-group sb-filter-search-group" role="group">
                        <input type="text" class="sb-filter-field sb-filter-search-input" placeholder="Search"
                            (input)="searchData($event)">
                        <button type="button" class="btn sb-filter-search-btn">
                            <!-- <i class="ri-search-line"></i> -->
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path
                                    d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
                                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M17.5 17.5L13.875 13.875" stroke="currentColor" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            <div class="table-wrap" [class.is-loading]="tableLoader">
                <div class="table-main position-relative">
                    <div class="loaderwrapper" *ngIf="tableLoader">
                        <span class="loader"></span>
                    </div>
                    <ng-container *ngIf="dataLoaded && auditTrailList?.length > 0">
                        <div class="table-responsive">
                            <table class="table-data">
                                <thead>
                                    <tr>
                                        <th>Action</th>
                                        <th>Message</th>
                                        <th>Changed By</th>
                                        <th>User Type</th>
                                        <th>Date & Time</th>
                                        <th>Details</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of auditTrailList">
                                        <td>
                                            <div class="tag" [ngClass]="getActionClass(item.action)">
                                                {{ item.action | titlecase }}
                                            </div>
                                        </td>
                                        <td>{{ item.message }}</td>
                                        <td>{{ item.changed_by }}</td>
                                        <td>{{ item.user_type }}</td>
                                        <td>{{ formatDate(item.created_at) }}</td>
                                        <td>
                                            <ul class="list-inline hstack gap-2 mb-0"
                                                *ngIf="hasOldData(item) || hasNewData(item)">
                                                <li class="list-inline-item view" data-bs-toggle="tooltip"
                                                    data-bs-trigger="hover" data-bs-placement="top" title="View">
                                                    <a title="View User Type" (click)="openDetailsModal(detailsModal, item)"
                                                        class="d-inline-block view-item-btn">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="21.841"
                                                            height="14.56" viewBox="0 0 21.841 14.56">
                                                            <g id="eye" transform="translate(-1.498 -9)">
                                                                <circle id="Ellipse_1436" data-name="Ellipse 1436"
                                                                    cx="3.105" cy="3.105" r="3.105"
                                                                    transform="translate(9.315 13.175)"
                                                                    fill="currentColor" />
                                                                <path id="Path_5515" data-name="Path 5515"
                                                                    d="M23.1,15.488a15.422,15.422,0,0,0-4.517-4.574A11.43,11.43,0,0,0,12.4,9a10.9,10.9,0,0,0-5.654,1.643,16.574,16.574,0,0,0-4.991,4.826,1.452,1.452,0,0,0-.029,1.617A15.2,15.2,0,0,0,6.2,21.666a11.271,11.271,0,0,0,6.2,1.894,11.478,11.478,0,0,0,6.2-1.9,15.2,15.2,0,0,0,4.508-4.592,1.465,1.465,0,0,0,0-1.582Zm-10.685,5.16a4.368,4.368,0,1,1,4.368-4.368,4.368,4.368,0,0,1-4.368,4.368Z"
                                                                    fill="currentColor" />
                                                            </g>
                                                        </svg>
                                                    </a>
                                                </li>
                                            </ul>
                                            <span *ngIf="!hasOldData(item) && !hasNewData(item)" class="text-muted">
                                                No data changes
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="table-meta">
                            <div class="entries">
                                <div class="dataTables_length p-0">
                                    <label class="show-entries-list">
                                        Show
                                        <select [formControl]="pageSizeControl" (change)="changePageSize()"
                                            class="form-control form-control-sm">
                                            <option *ngFor="let limit of pageRecordOptions" [value]="limit.value">
                                                {{limit.label}}</option>
                                        </select>
                                        entries
                                    </label>
                                </div>
                                <span>Total Records: {{this.total_items }}</span>
                            </div>
                            <nav class="table-pagination">
                                <ul>
                                    <li>
                                        <div class="go-to-page d-flex align-items-center">
                                            <label>Go to Page:</label>
                                            <input type="number" class="form-control form-control-sm" [(ngModel)]="pageToGo"
                                                min="1" [max]="total_pages"
                                                (keydown.enter)="goToPage(pageToGo); pageToGo = null">
                                            <div class="input-group-append">
                                                <button class="btn btn-primary" type="button"
                                                    (click)="goToPage(pageToGo); pageToGo = null"
                                                    [disabled]="pageToGo < 1 || pageToGo > total_pages">Go</button>
                                            </div>
                                        </div>
                                    </li>
                                    <li><a class="init-bg" id="firstPage" (click)="goToPage(1)"
                                            [class.disabled]="current_page === 1">1</a>
                                    </li>
                                    <li><a class="no-bg" id="prevPage" (click)="navigatePage('prev')"><i
                                                class="fa fa-chevron-left"></i></a>
                                    </li>
                                    <li><a class="active">{{ current_page }}</a></li>
                                    <li><a class="no-bg" id="nextPage" (click)="navigatePage('next')"
                                            [class.disabled]="current_page === total_pages"><i
                                                class="fa fa-chevron-right"></i></a></li>
                                    <li><a class="init-bg" id="lastPage" (click)="goToPage(total_pages)"
                                            [class.disabled]="current_page === total_pages">{{this.total_pages}}</a></li>
                                </ul>
                            </nav>
                        </div>
                    </ng-container>
                    <!-- NO RECORDS -->
                    <div *ngIf="dataLoaded && !loader && auditTrailList?.length === 0"
                        class="empty-state text-center text-muted d-flex flex-column align-items-center justify-content-center">
                        <i class="fa fa-history mb-2"></i>
                        <span>No activity yet</span>
                    </div>
                    <div *ngIf="permissionsReady && !permissions.canView"
                        class="empty-state text-center text-muted d-flex flex-column align-items-center justify-content-center">
                        <i class="fa fa-lock fa-2x mb-2"></i>
                        <span>You don’t have permission to view this data.</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Details Modal -->
<ng-template #detailsModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title">
            Audit Trail Details
            <span class="tag ml-2" [ngClass]="getActionClass(selectedItem?.action)">
                {{ selectedItem?.action | titlecase }}
            </span>
        </h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                <rect y="0.696289" width="24" height="24" rx="12" fill="white" />
                <path d="M6.99988 7.69653L12.0514 12.748L17.1029 7.69653" stroke="currentColor" stroke-width="1.6"
                    stroke-linecap="round" stroke-linejoin="round" />
                <path d="M6.99995 18.3679L12.0505 13.3164L17.1021 18.3679" stroke="currentColor" stroke-width="1.6"
                    stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </button>
    </div>
    <div class="modal-body">
        <div class="mb-3">
            <p><strong>Message:</strong> {{ selectedItem?.message }}</p>
            <p><strong>Changed By:</strong> {{ selectedItem?.changed_by }}</p>
            <p><strong>Date & Time:</strong> {{ formatDate(selectedItem?.created_at) }}</p>
        </div>

        <div class="table-responsive" style="border-radius: 20px;">
            <table class="table">
                <thead class="thead-gray">
                    <tr>
                        <th style="width: 25%;">Field</th>
                        <th style="width: 37.5%;">Old Data</th>
                        <th style="width: 37.5%;">New Data</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let field of getAllFields(selectedItem)">
                        <td><strong>{{ field }}</strong></td>
                        <td>
                            <span *ngIf="selectedItem?.old_data && selectedItem.old_data[field]">
                                {{ selectedItem.old_data[field] }}
                            </span>
                            <span *ngIf="!selectedItem?.old_data || !selectedItem.old_data[field]"
                                class="text-muted">—</span>
                        </td>
                        <td>
                            <span *ngIf="selectedItem?.new_data && selectedItem.new_data[field]">
                                {{ selectedItem.new_data[field] }}
                            </span>
                            <span *ngIf="!selectedItem?.new_data || !selectedItem.new_data[field]"
                                class="text-muted">—</span>
                        </td>
                    </tr>
                    <tr *ngIf="getAllFields(selectedItem)?.length === 0">
                        <td colspan="3" class="text-center text-muted">No data changes recorded</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="modal.dismiss()">Close</button>
    </div>
</ng-template>